<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'plans/solutions/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      @search="searchPlan"
      :searchTag="false"
      :searchValue="searchValue"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('TITLE'),
        })
      "
      :showSearch="true"
    >
      <el-form-item :label="$t('START_DATE')" prop="dateRange.start">
        <date-picker
          v-model="dateRange.start"
          type="date"
          :locale="$i18n.locale"
          format="jYYYY-jMM-jDD"
          @change="handleDateChange"
          color="#151515"
          class="el-input__inner"
          clearable
        />
      </el-form-item>
      <el-form-item :label="$t('END_DATE')" prop="dateRange.end">
        <date-picker
          v-model="dateRange.end"
          type="date"
          :locale="$i18n.locale"
          format="jYYYY-jMM-jDD"
          @change="handleDateChange"
          color="#151515"
          class="el-input__inner"
          clearable
        />
      </el-form-item>

      
    </tableSearch>

    <div class="mb-4 flex justify-end items-center">
      <el-button
        
        @click="downloadPlan"
        type="info"
      size="small"
      round
        icon="el-icon-download"
        :loading="downloading"
      >
        {{ $t('DOWNLOAD') }}
      </el-button>
    </div>

    

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="right" :label="$t('TITLE')" width="160">
        <template slot-scope="scope">
          <div
            :data-title="$t('TITLE')"
          >
        {{ scope.row.title }}
        </div>
        </template>
      </el-table-column>

      <el-table-column align="center" :label="$t('DATE')" width="160">
        <template slot-scope="scope">
          <div
            class="flex items-center justify-center"
            :data-title="$t('DATE')"
            v-html="formatDateTime(scope.row.date, true)"
          ></div>
        </template>
      </el-table-column>

      <el-table-column align="center" :label="$t('ROUTES_COUNT')" width="120">
        <template slot-scope="scope">
          <div :data-title="$t('ROUTES_COUNT')">
            <el-tag type="info" size="small">
              {{ scope.row.routes.length }} {{ $t('ROUTE') }}
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" :label="$t('TOTAL_VISITS')" width="120">
        <template slot-scope="scope">
          <div :data-title="$t('TOTAL_VISITS')">
            <el-tag type="success" size="small">
              {{ getTotalVisits(scope.row.routes) }}
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        width="150"
      >
        <template slot-scope="scope">
          <div class="flex gap-2" v-if="scope.row.routes.length > 0">
            <el-button
              @click="viewDetails(scope.row)"
              type="primary"
              size="mini"
              icon="el-icon-view"
            >
              {{ $t('VIEW_DETAILS') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- Details Modal -->
    <el-dialog
      :visible.sync="detailsVisible"
      width="80%"
      :before-close="closeDetails"
      :append-to-body="true"
      :modal-append-to-body="true"
      top="2vh"
      custom-class="top-dialog"
    >
      <div v-if="selectedPlan">
        <!-- Route Selection Tabs -->
        <el-tabs
          v-model="selectedRouteIndex"
          @tab-click="onRouteTabClick"
          class="mb-4"
          type="card"
        >
          <el-tab-pane
            v-for="(route, index) in selectedPlan.routes"
            :key="route.id"
            :label="$t('ROUTE') + ' ' + (index + 1)"
            :name="index.toString()"
          >
            <!-- Route Summary Card -->
            <div class="bg-gray-50 p-4 rounded-lg border mb-4">
              <div class="flex md:flex-row flex-col justify-between mb-3">
                <LicensePlate
                  v-if="route.company_vehicle"
                  :vehicle="route.company_vehicle.vehicle"
                  :license_plate="route.company_vehicle.license_plate"
                  :chars="alphaList"
                  size="small"
                />
                <div class="flex items-center gap-2" v-if="route.driver">
                  <strong>{{ $t('DRIVER_TITLE') }}:</strong>
                  <span>
                    {{
                      route.driver
                        ? route.driver.first_name + ' ' + route.driver.last_name
                        : $t('NO_DRIVER')
                    }}
                  </span>
                </div>
                <div class="flex items-center gap-2">
                  <strong>{{ $t('START_TIME') }}:</strong>
                  <span v-html="formatDateTime(route.start)"></span>
                </div>
                <div class="flex items-center gap-2">
                  <strong>{{ $t('END_TIME') }}:</strong>
                  <span v-html="formatDateTime(route.stop)"></span>
                </div>
                <el-tag size="small" type="info">
                  {{ route.visits.length }}
                  {{ $t('VISITS_COUNT') }}
                </el-tag>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- Map -->
        <div class="mb-4">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-md font-medium">{{ $t('VISITS_MAP') }}</h3>
            <el-button
              type="warning"
              size="small"
              icon="el-icon-thermometer"
              @click="toggleTemperatureMode"
              :disabled="!selectedRoute || mapLoading"
            >
              بررسی دما
            </el-button>
          </div>
          <div
            v-if="temperatureMode"
            class="
              bg-yellow-50
              border border-yellow-200
              rounded
              p-2
              mb-2
              text-sm
            "
          >
            <div class="flex items-center gap-2">
              <i class="el-icon-info text-yellow-600"></i>
              <span>
                {{
                  selectedPoints.length === 0
                    ? 'روی نقاط بازدید (پین‌های قرمز) کلیک کنید تا نقطه اول را انتخاب کنید'
                    : selectedPoints.length === 1
                    ? 'روی نقطه بازدید دوم کلیک کنید'
                    : 'در حال بررسی دما...'
                }}
              </span>
              <el-button
                v-if="selectedPoints.length > 0"
                type="text"
                size="mini"
                @click="
                  () => {
                    cancelTemperatureMode()
                    closeTemperatureChart()
                  }
                "
              >
                لغو
              </el-button>
            </div>
          </div>
          <div
            id="visitsMap"
            class="w-full h-96 rounded-lg border"
            v-loading="mapLoading"
          ></div>
        </div>

        <!-- Temperature Chart Section -->
        <div v-if="showTemperatureChart" class="mt-6">
          <div class="bg-white border rounded-lg p-4">
            <!-- Chart Header -->
            <div class="flex justify-between items-center mb-4">
              <h3 class="text-lg font-medium" v-html="chartTitle"></h3>
              <el-button
                type="text"
                icon="el-icon-close"
                @click="closeTemperatureChart"
                class="text-gray-500 hover:text-gray-700"
              ></el-button>
            </div>

            <div v-if="chartLoading" class="text-center py-8">
              <i class="el-icon-loading text-2xl"></i>
              <p class="mt-2">{{ $t('LOADING') }}...</p>
            </div>

            <div v-else>
              <div class="mb-4">
                <VueApexCharts
                  v-if="chartData.length > 0"
                  type="area"
                  height="350"
                  :options="chartOptions"
                  :series="chartData"
                />
                <div v-else class="text-center py-8 text-gray-500">
                  {{ $t('NO_DATA') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </Content>
</template>

<script>
import { plansSolutionsList, exportPlan } from '@/api/plans'
import { licenseChars } from '@/api/global'
import { vehicleTemperatureTracking } from '@/api/reports'
import LicensePlate from '@/components/cars/LicensePlate'
import VueApexCharts from 'vue-apexcharts'
import tableSearch from '@/components/elements/tableSearch'
import { License } from '@/mixins/License'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import config from '@/configs/configs.js'

export default {
  mixins: [License, jalaliToGregorian],
  data() {
    return {
      tableData: {
        results: [],
        count: 0,
      },
      loading: true,
      downloading: false,
      searchValue: '',
      dateRange: {
        start: null,
        end: null,
      },
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      detailsVisible: false,
      selectedPlan: null,
      selectedRouteIndex: '0',
      visitsMap: null,
      mapLoading: false,
      temperatureMode: false,
      selectedPoints: [],
      temperatureMarkers: [],
      temperatureLine: null,

      // Temperature chart data
      showTemperatureChart: false,
      chartLoading: false,
      chartData: [],
      chartTitle: '',
      temperatureChartData: null,

      chartOptions: {
        chart: {
          id: 'temperature-chart',
          height: 350,
          type: 'area',
          stacked: false,
          toolbar: {
            show: true,
            autoSelected: 'zoom',
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
          },
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true,
          },
          selection: {
            enabled: true,
            type: 'x',
          },
          fontFamily: 'Vazir',
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: 'hollow',
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0.1,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          type: 'datetime',
          tickAmount: 6,
          labels: {
            formatter: function (value, timestamp) {
              return (
                new Date(timestamp).toLocaleDateString('fa-IR') +
                ' ' +
                new Date(timestamp).toLocaleTimeString('fa-IR', {
                  hour: '2-digit',
                  minute: '2-digit',
                })
              )
            },
            style: {
              fontSize: '12px',
            },
            rotate: -45,
            rotateAlways: false,
          },
          title: {
            text: 'زمان',
            style: {
              fontSize: '14px',
              fontWeight: 600,
            },
          },
        },
        yaxis: {
          title: {
            text: 'دما (°C)',
            style: {
              fontSize: '14px',
              fontWeight: 600,
            },
          },
          labels: {
            formatter: function (value) {
              return value?.toFixed(1) + '°C'
            },
          },
        },
        tooltip: {
          shared: false,
          y: {
            formatter: function (value) {
              return value + '°C'
            },
          },
          x: {
            formatter: function (value) {
              return new Date(value).toLocaleString('fa-IR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })
            },
          },
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        colors: ['#008FFB'],
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'left',
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                height: 250,
              },
              xaxis: {
                labels: {
                  rotate: -90,
                },
              },
            },
          },
        ],
      },
    }
  },

  computed: {
    selectedRoute() {
      const routeIndex = parseInt(this.selectedRouteIndex)
      return this.selectedPlan?.routes?.[routeIndex] || null
    },
  },

  methods: {
    formatDateTime(datetime, isDateOnly = false) {
      if (!datetime) return '-'
      const date = new Date(datetime)

      return isDateOnly
        ? date.toLocaleDateString('fa-IR')
        : `<div class="flex items-center space-x-1 flex-row-reverse">${date.toLocaleDateString(
            'fa-IR'
          )}<span class="text-gray-500 symbol ml-1">|</span><span>${date.toLocaleTimeString(
            'fa-IR'
          )}</span></div>`
    },

    formatDateForDisplay(date) {
      if (!date) return '-'
      const d = date instanceof Date ? date : new Date(date)
      return d.toLocaleDateString('fa-IR')
    },

    formatDateTimeForTitle(datetime) {
      if (!datetime) return '-'
      const date = datetime instanceof Date ? datetime : new Date(datetime)
      return `${date.toLocaleDateString(
        'fa-IR'
      )} <span class="text-gray-500 symbol ml-1">|</span> ${date.toLocaleTimeString(
        'fa-IR',
        {
          hour: '2-digit',
          minute: '2-digit',
        }
      )}`
    },

    getTotalVisits(routes) {
      return routes.reduce((total, route) => total + route.visits.length, 0)
    },

    searchPlan(val) {
      this.searchValue = val
      this.fetchData()
    },

    handleDateChange() {
      this.fetchData()
    },

    fetchData() {
      this.loading = true

      const searchParams = {}

      if (this.searchValue) {
        searchParams.search = this.searchValue
      }

      if (this.dateRange.start) {
        searchParams.date__gte = this.jalaliToGregorian(
          this.dateRange.start,
          this.$i18n.locale
        )
      }

      if (this.dateRange.end) {
        searchParams.date__lte = this.jalaliToGregorian(
          this.dateRange.end,
          this.$i18n.locale
        )
      }

      plansSolutionsList.api(searchParams).then((res) => {
        if (res) {
          this.tableData = res
        }
        this.loading = false
      })
    },

    viewDetails(plan) {
      this.selectedPlan = plan
      this.selectedRouteIndex = '0'
      this.detailsVisible = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.initializeVisitsMap()
        }, 100)
      })
    },

    onRouteTabClick(tab) {
      this.selectedRouteIndex = tab.name
      this.cancelTemperatureMode()
      this.closeTemperatureChart()
      this.$nextTick(() => {
        setTimeout(() => {
          this.initializeVisitsMap()
        }, 100)
      })
    },

    closeDetails() {
      this.detailsVisible = false
      this.selectedPlan = null
      this.selectedRouteIndex = '0'
      this.cancelTemperatureMode()
      this.closeTemperatureChart()
      if (this.visitsMap) {
        this.visitsMap.remove()
        this.visitsMap = null
      }
    },

    initializeVisitsMap() {
      if (this.visitsMap) {
        this.visitsMap.remove()
        this.visitsMap = null
      }

      this.mapLoading = true

      const mapContainer = document.getElementById('visitsMap')
      if (!mapContainer) {
        console.warn('Map container not found')
        this.mapLoading = false
        return
      }

      this.visitsMap = L.map('visitsMap').setView([35.7, 51.4], 10)

      L.tileLayer(config.tile, {
        attribution: '@ Carpo',
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: config.leaflet,
      }).addTo(this.visitsMap)

      const routeIndex = parseInt(this.selectedRouteIndex)
      const selectedRoute = this.selectedPlan?.routes?.[routeIndex]

      if (!selectedRoute) {
        console.warn(`No route found at index ${routeIndex}`)
        this.mapLoading = false
        return
      }

      const routeVisits = selectedRoute.visits || []

      if (routeVisits.length > 0) {
        const group = new L.featureGroup()
        let validMarkersCount = 0

        routeVisits.forEach((visit, visitIndex) => {
          const lat = parseFloat(visit.latitude)
          const lng = parseFloat(visit.longitude)

          if (!isNaN(lat) && !isNaN(lng)) {
            const indexIcon = L.divIcon({
              className: 'index-icon',
              html: `<div>${visitIndex + 1}</div>`,
            })

            const marker = L.marker([lat, lng], {
              icon: indexIcon,
            }).addTo(this.visitsMap)

            // Add click listener for temperature mode
            marker.on('click', (e) => {
              this.onVisitMarkerClick(visit, marker, e, visitIndex)
            })

            const popupContent = `
              <div class="text-right leading-6">
                <div class="mb-3 border-b pb-2">
                  <div class="text-xs text-blue-600 font-medium mb-1">
                    ${this.$t('ROUTE')} ${routeIndex + 1} - ${visitIndex + 1}
                  </div>
                  <div class="font-semibold text-lg mb-1">
                    ${
                      selectedRoute.driver
                        ? selectedRoute.driver.first_name +
                          ' ' +
                          selectedRoute.driver.last_name
                        : this.$t('NO_DRIVER')
                    }
                  </div>
                  <div class="text-sm text-gray-600">
                    ${
                      selectedRoute.company_vehicle
                        ? this.formatVehicleInfo(
                            selectedRoute.company_vehicle.vehicle
                          )
                        : this.$t('NO_VEHICLE')
                    }
                  </div>
                  <div class="text-xs text-gray-500 mt-1">
                    ${this.$t(
                      'ROUTE_PERIOD'
                    )}: <div class='flex flex-row-reverse items-center justify-start gap-2'>${this.formatDateTime(
              selectedRoute.start
            )} <span> - </span>${this.formatDateTime(selectedRoute.stop)}</div>
                  </div>
                </div>
                
                <div class="space-y-2">
                  <div class="flex justify-between">
                    <span class="font-medium">${this.$t(
                      'EXPECTED_TIME'
                    )}:</span>
                    <span>${this.formatDateTime(visit.expected_datetime)}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="font-medium">${this.$t(
                      'arrival_datetime'
                    )}:</span>
                    <span>${this.formatDateTime(visit.arrival_datetime)}</span>
                  </div>
                  <div class="flex justify-between">
                    <span class="font-medium">${this.$t(
                      'delivery_datetime'
                    )}:</span>
                    <span>${this.formatDateTime(visit.delivery_datetime)}</span>
                  </div>
                  ${
                    visit.shipment_id
                      ? `
                    <div class="flex justify-between">
                      <span class="font-medium">${this.$t(
                        'SHIPMENT_ID'
                      )}:</span>
                      <span class="text-blue-600">${visit.shipment_id}</span>
                    </div>
                  `
                      : ''
                  }
                  <div class="flex justify-between text-sm text-gray-600">
                    <span>${this.$t('COORDINATES')}:</span>
                    <span class="ltr">${lat.toFixed(6)}, ${lng.toFixed(
              6
            )}</span>
                  </div>
                </div>
              </div>
            `

            marker.bindPopup(popupContent, { minWidth: 300 })
            group.addLayer(marker)
            validMarkersCount++
          } else {
            console.warn(
              `Invalid coordinates for visit ${visitIndex + 1}: ${
                visit.latitude
              }, ${visit.longitude}`
            )
          }
        })

        if (group.getLayers().length > 0) {
          this.visitsMap.fitBounds(group.getBounds(), { padding: [20, 20] })
          console.log(`Map fitted to bounds with ${validMarkersCount} markers`)
        }
      } else {
        console.log('No visits found for this route')
      }

      this.mapLoading = false
    },

    formatVehicleInfo(vehicle) {
      if (!vehicle) return this.$t('NO_VEHICLE')
      const manufacturer =
        this.$i18n.locale === 'fa'
          ? vehicle.vehicle_manufacturer_company?.fa_title
          : vehicle.vehicle_manufacturer_company?.en_title
      const vehicleTitle =
        this.$i18n.locale === 'fa' ? vehicle.fa_title : vehicle.en_title
      return manufacturer ? `${vehicleTitle} - ${manufacturer}` : vehicleTitle
    },

    loadInitialData() {
      licenseChars.api().then((res) => {
        this.alphaList = res
      })
    },

    toggleTemperatureMode() {
      this.temperatureMode = !this.temperatureMode
      if (this.temperatureMode) {
        this.selectedPoints = []
        this.clearTemperatureMarkers()

        // No need to add general map click listener anymore
        // Visit markers will handle clicks directly
      } else {
        this.cancelTemperatureMode()
        this.closeTemperatureChart()
      }
    },

    cancelTemperatureMode() {
      this.temperatureMode = false
      this.clearTemperatureMarkers()
      this.selectedPoints = []
      // No need to remove general map click listener anymore
    },

    addVisitMarkersClickListener() {
      // This will be called when initializing the map to add click listeners to visit markers
    },

    removeVisitMarkersClickListener() {
      // Remove click listeners from visit markers - handled when markers are removed
    },

    onVisitMarkerClick(visit, marker, e, visitIndex) {
      if (!this.temperatureMode || this.selectedPoints.length >= 2) return

      // Store original icon before modifying
      const originalIcon = marker.getIcon()

      const point = {
        lat: parseFloat(visit.latitude),
        lng: parseFloat(visit.longitude),
        latlng: e.latlng,
        visit: visit,
        marker: marker,
        originalIcon: originalIcon,
        visitIndex: visitIndex, // Store the visit index for restoration
      }

      this.selectedPoints.push(point)

      // Change the existing marker's appearance for selection
      const selectionColor =
        this.selectedPoints.length === 1 ? '#ff4444' : '#4444ff'
      const label = this.selectedPoints.length === 1 ? 'A' : 'B'
      const selectionIcon = this.generateSelectionMarker(selectionColor, label)
      marker.setIcon(selectionIcon)

      // Store the marker reference for cleanup
      this.temperatureMarkers.push(marker)

      // If we have 2 points, draw line and make API call
      if (this.selectedPoints.length === 2) {
        this.drawTemperatureLine()
        this.analyzeTemperature()
      }
    },

    generateSelectionMarker(color, label) {
      return L.divIcon({
        html: `<div style="background-color: ${color}; width: 30px; height: 30px; border-radius: 50%; border: 3px solid white; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 14px; box-shadow: 0 2px 6px rgba(0,0,0,0.3);">${label}</div>`,
        className: '',
        iconSize: [30, 30],
        iconAnchor: [15, 15],
      })
    },

    drawTemperatureLine() {
      if (this.selectedPoints.length !== 2) return

      const pointA = this.selectedPoints[0]
      const pointB = this.selectedPoints[1]

      const startLocation = [pointA.lat, pointA.lng]
      const endLocation = [pointB.lat, pointB.lng]

      // Use the same curved path logic as OverviewMap
      const offsetX = endLocation[1] - startLocation[1]
      const offsetY = endLocation[0] - startLocation[0]
      const r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2))
      const theta = Math.atan2(offsetY, offsetX)
      const thetaOffset = 3.14 / 10
      const theta2 = theta + thetaOffset
      const r2 = r / 2 / Math.cos(thetaOffset)
      const midpointX = r2 * Math.cos(theta2) + startLocation[1]
      const midpointY = r2 * Math.sin(theta2) + startLocation[0]
      const midpointLatLng = [midpointY, midpointX]

      const pathOptions = {
        color: '#ff6b35',
        weight: 4,
        opacity: 0.8,
      }

      this.temperatureLine = L.curve(
        ['M', startLocation, 'Q', midpointLatLng, endLocation],
        pathOptions
      ).addTo(this.visitsMap)
    },

    analyzeTemperature() {
      if (!this.selectedRoute || !this.selectedRoute.company_vehicle) {
        this.$message.error('اطلاعات وسیله نقلیه یافت نشد')
        return
      }

      if (this.selectedPoints.length !== 2) {
        this.$message.error('لطفاً دو نقطه بازدید انتخاب کنید')
        return
      }

      const pointA = this.selectedPoints[0]
      const pointB = this.selectedPoints[1]
      const visitA = pointA.visit
      const visitB = pointB.visit

      if (!visitA || !visitB) {
        this.$message.error('اطلاعات بازدیدها یافت نشد')
        return
      }

      // Use expected_datetime as timestamps
      const startRange = visitA.arrival_datetime
      const stopRange = visitB.arrival_datetime

      if (!startRange || !stopRange) {
        this.$message.error('زمان‌بندی بازدیدها یافت نشد')
        return
      }

      // Ensure chronological order
      const orderedStart =
        new Date(startRange) < new Date(stopRange) ? startRange : stopRange
      const orderedStop =
        new Date(startRange) < new Date(stopRange) ? stopRange : startRange

      this.mapLoading = true

      vehicleTemperatureTracking
        .api(
          this.selectedRoute.company_vehicle.id,
          new Date(orderedStart).getTime() / 1000,
          new Date(orderedStop).getTime() / 1000
        )
        .then((response) => {
          this.mapLoading = false
          this.showTemperatureResults(response, visitA, visitB)
        })
        .catch((error) => {
          this.mapLoading = false
          this.$message.error('خطا در دریافت اطلاعات دمایی')
          console.error('Temperature tracking error:', error)
        })
    },

    showTemperatureResults(data, visitA, visitB) {
      try {
        // Set chart title with time range (sorted chronologically)
        const timeA = new Date(visitA.arrival_datetime)
        const timeB = new Date(visitB.arrival_datetime)

        // Sort times to ensure chronological order
        const earlierTime = timeA < timeB ? timeA : timeB
        const laterTime = timeA < timeB ? timeB : timeA

        const startTime = this.formatDateTimeForTitle(earlierTime)
        const endTime = this.formatDateTimeForTitle(laterTime)

        this.chartTitle = `${this.$t('temperature')}  ${
          this.License(
            this.selectedRoute.company_vehicle.license_plate,
            this.alphaList
          ) || 'نامشخص'
        } - ${startTime} تا ${endTime}`

        // Process temperature data for chart from the API structure
        if (
          data &&
          data.metric &&
          data.metric.data &&
          Array.isArray(data.metric.data)
        ) {
          const chartData = data.metric.data.map((item) => ({
            x: new Date(item.datetime).getTime(),
            y: parseFloat(item.value),
          }))

          // Sort data by timestamp to ensure proper chart display
          chartData.sort((a, b) => a.x - b.x)

          this.chartData = [
            {
              name: this.$t('temperature'),
              data: chartData,
            },
          ]

          this.showTemperatureChart = true
          this.temperatureChartData = data

          setTimeout(() => {
            const chartSection = document.querySelector(
              'h3.text-lg.font-medium'
            )

            if (chartSection) {
              const dialogBody = document.querySelector('.el-dialog__wrapper')
              if (dialogBody) {
                const chartRect = chartSection.getBoundingClientRect()
                const dialogRect = dialogBody.getBoundingClientRect()
                const scrollTop =
                  chartRect.top - dialogRect.top + dialogBody.scrollTop - 20

                dialogBody.scrollTo({
                  top: scrollTop,
                  behavior: 'smooth',
                })
              }
            }
          }, 300)
        } else if (
          data &&
          data.temperature_data &&
          Array.isArray(data.temperature_data)
        ) {
          // Fallback for old API structure
          const chartData = data.temperature_data.map((item) => ({
            x: new Date(item.timestamp).getTime(),
            y: parseFloat(item.temperature),
          }))

          chartData.sort((a, b) => a.x - b.x)

          this.chartData = [
            {
              name: this.$t('temperature'),
              data: chartData,
            },
          ]

          this.showTemperatureChart = true
          this.temperatureChartData = data
          // Scroll to chart after it's rendered
          this.$nextTick(() => {
            setTimeout(() => {
              const chartSection = document.querySelector(
                'h3.text-lg.font-medium'
              )
              console.log(chartSection)
              if (chartSection) {
                chartSection.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                })
              }
            }, 300)
          })
        } else {
          // If no temperature data, show error message
          this.$notify.error({
            title: 'بررسی دما',
            message: 'داده دمایی برای این بازه زمانی یافت نشد',
            duration: 5000,
          })
        }
      } catch (error) {
        console.error('Error processing temperature data:', error)
        this.$notify.error({
          title: 'خطا',
          message: 'خطا در پردازش داده‌های دمایی',
          duration: 5000,
        })
      }

      // Reset temperature mode
    },

    closeTemperatureChart() {
      this.showTemperatureChart = false
      this.chartData = []
      this.chartTitle = ''
      this.temperatureChartData = null
      this.cancelTemperatureMode()
    },

    clearTemperatureMarkers() {
      // Restore original icons for selected markers
      this.selectedPoints.forEach((point, index) => {
        if (point.marker) {
          if (point.originalIcon) {
            point.marker.setIcon(point.originalIcon)
          } else {
            // If no original icon stored, recreate the index icon
            const indexIcon = L.divIcon({
              className: 'index-icon',
              html: `<div>${point.visitIndex + 1}</div>`,
            })
            point.marker.setIcon(indexIcon)
          }
        } else {
          console.warn('Missing marker for point:', point)
        }
      })

      this.temperatureMarkers = []

      if (this.temperatureLine && this.visitsMap) {
        this.visitsMap.removeLayer(this.temperatureLine)
        this.temperatureLine = null
      }
    },

    downloadPlan() {
      // Dates are optional; if provided, convert from Jalali to Gregorian (YYYY-MM-DD)
      let fromDateStr = ''
      let toDateStr = ''

      if (this.dateRange.start) {
        fromDateStr = this.jalaliToGregorian(
          this.dateRange.start,
          this.$i18n.locale
        )
      }

      if (this.dateRange.end) {
        toDateStr = this.jalaliToGregorian(
          this.dateRange.end,
          this.$i18n.locale
        )
      }

      this.downloading = true

      exportPlan
        .api(fromDateStr, toDateStr)
        .then((blob) => {
          if (!blob) {
            this.$message.error('خطا در دانلود فایل')
            return
          }
          // Create download link
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url

          // Format date for filename
          link.download = `plan-${fromDateStr}-to-${toDateStr}-CARPO.xlsx`

          document.body.appendChild(link)
          link.click()

          // Cleanup
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)

          this.$message.success(
            'دانلود با موفقیت انجام شد'
          )
        })
        .catch((error) => {
          console.error('Download error:', error)
          this.$message.error(this.$t('DOWNLOAD_ERROR') || 'خطا در دانلود فایل')
        })
        .finally(() => {
          this.downloading = false
        })
    },
  },

  mounted() {
    this.fetchData()
    this.loadInitialData()
  },

  components: {
    LicensePlate,
    VueApexCharts,
    tableSearch,
  },
}
</script>

<style scoped>
.space-y-1 > * + * {
  margin-top: 0.25rem;
}

.space-x-2 > * + * {
  margin-left: 0.5rem;
}

#visitsMap {
  z-index: 1;
}

.pulse {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #67c23a;
  cursor: pointer;
  box-shadow: 0 0 0 rgba(103, 194, 58, 0.4);
  animation: pulse 2s infinite;
}

.pulse:hover {
  animation: none;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(103, 194, 58, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(103, 194, 58, 0);
  }
}

.el-tabs__item {
  font-weight: 600;
  color: #606266;
}

.el-tabs__item.is-active {
  color: #409eff;
  font-weight: 700;
}

/* Dialog on top styles */
.top-dialog {
  z-index: 9999 !important;
}

.top-dialog .el-dialog {
  z-index: 9999 !important;
}

.top-dialog .el-dialog__wrapper {
  z-index: 9999 !important;
}

/* Ensure modal backdrop appears below dialog */
.v-modal {
  z-index: 9998 !important;
}
</style>
